import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AppBar } from "@mui/material";
import { HeaderContainer, NavContainter } from "./styles";
import logo from "./assets/logo.svg";
import { ProfileMenu } from "./components/ProfileMenu";
import { AuthContext } from "../../context/AuthContext";
import { FALE_CONOSCO_ROUTE } from "../../global/constants/routes/defaultConstants";

export function Navbar() {
  const { user } = useContext(AuthContext);

  const userName = user
    ? [user.firstName, user.lastName].filter(Boolean).join(" ") || user.username
    : "";

  return (
    <AppBar elevation={0}>
      <HeaderContainer>
        <NavLink to="/">
          <img src={logo} alt="logo" />
        </NavLink>
        <NavContainter>
          <NavLink to="/" end>
            <span>Mapa</span>
          </NavLink>
          <NavLink to="/duvidas">
            <span>Glossário</span>
          </NavLink>
          <NavLink to="/perguntas-frequentes">
            <span>Perguntas Frequentes</span>
          </NavLink>
          <NavLink to={FALE_CONOSCO_ROUTE}>
            <span>Fale Conosco</span>
          </NavLink>
        </NavContainter>
        <ProfileMenu userName={userName} />
      </HeaderContainer>
    </AppBar>
  );
}
